// src/routes/ProtectedRoute.tsx
import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import { RootState } from '../store';

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const token =
    useSelector((state: RootState) => state.auth.token) ||
    Cookies.get('authToken');

  if (!token || token === 'undefined') {
    return <Navigate to="/register" />;
  }

  return children;
};

export default ProtectedRoute;
